import * as Cookies from "es-cookie"

export const DLogin = async ({ prompt, fromButton }) => {
  const createAuthState = async () => {
    const crypto = require("crypto")
    const buff = crypto.randomBytes(8)
    const hex = buff.toString("hex")
    const currentPath = encodeURIComponent(window.location.pathname)
    const state = hex + currentPath
    Cookies.set("authStateToken", state)
    return state
  }

  const createNonce = async () => {
    const crypto = require("crypto")
    const buff = crypto.randomBytes(8)
    const hex = buff.toString("hex")
    const currentPath = encodeURIComponent(window.location.pathname)
    const nonce = hex + currentPath
    Cookies.set("nonce", nonce)
    return nonce
  }

  // 認証APIのエンドポイント設定
  const daccountEndpoint = process.env.REACT_APP_DLOGIN_ENDPOINT
  const uri = daccountEndpoint + "/cgi8/oidc/authorize"
  const createdAuthState = await createAuthState()
  const createdNonce = await createNonce()

  const queryString = [
    "scope=openid%20accountid_n%20p_dashboard%20offline_access",
    "response_type=code",
    `redirect_uri=${process.env.REACT_APP_D_AUTH_REDIRECT_URI}`,
    `client_id=${process.env.REACT_APP_D_AUTH_CLIENT_ID}`,
    `state=${createdAuthState}`,
    `nonce=${createdNonce}`,
    "authif=1",
  ].join("&")

  const loginUri = `${uri}?${queryString}`

  if (prompt) {
    // 400系エラーでログイン画面にリダイレクト
    window.location.replace(loginUri + "&prompt=login")
  } else if (fromButton) {
    //ヘッダーのログインボタンからログイン画面に遷移
    window.location.href = loginUri
  } else {
    //未認証状態で要認証画面にアクセスし、ログイン画面にリダイレクト
    window.location.replace(loginUri)
  }
}
